import React from 'react';
import { z } from 'zod';
import { Col, Container, Row, Form } from 'shared-portal-component';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@/store';
import { setDraftField, setStep } from '@/store/slices/createSix/createSixSlice';
import { selectDraft } from '@/store/selectors/createSix';

/**
 * Zod schema for the SIX name step form.
 */
const MIN = 1;
const schema = z.object({
  name: z.string().min(MIN, 'Name is required'),
});

/**
 * StepName – First step in "Create SIX" multi-step modal.
 * Uses field-based Form, Redux state, and async validation.
 */
const StepName: React.FC = () => {
  const dispatch = useAppDispatch();
  const draft = useSelector(selectDraft);
  /**
   * Form fields config for the name step.
   */
  const fields = [
    {
      name: 'name',
      placeholder: 'Enter a name for your new SIX',
      required: true,
      variant: 'outline' as const,
      type: 'text',
    },
  ];

  /**
   * Handles the form submit for this step.
   * Dispatches async validation before advancing.
   */
  const handleSubmit = (values: { name: string }) => {
    // Await the async thunk
    // const result = await dispatch(validateSixName(values.name));
    // if (validateSixName.fulfilled.match(result)) {
      dispatch(setDraftField({ key: "name", value: values.name }));
    dispatch(setStep('Description'));
    // }
    // Errors will show below the field via your Form field error logic
  };

  return (
    <Container fluid>
      <Row spacing="md" justify="center">
        <Col md={7} sm={10} xs={12}>
          <Form
            schema={schema}
            fields={fields}
            onSubmit={handleSubmit}
            defaultValues={{
              name: draft.name,
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default StepName;
